<!--footer-->
<footer class="footer mt-auto bg-black text-white py-4 no-print">
	<div class="container px-lg-0">
		<div class="row no-gutters text-center text-lg-left">
			<div class="col-lg-10 d-lg-flex">
				<div class="mt-2"><img src="./assets/media/bandiera-footer.png" width="20" /></div>
				<div>
					<ul class="list-group list-group-horizontal-sm link-footer">
						<li class="list-group-item"><a>United States</a></li>
						<li class="list-group-item"><a>Catalogue</a></li>
						<li class="list-group-item"><a>Specifications Library</a></li>
						<li class="list-group-item"><a>Terms & Conditions</a></li>
						<li class="list-group-item"><a>Privacy Policy</a></li>
						<li class="list-group-item"><a>Ethical Code</a></li>
						<li class="list-group-item"><a>Contact Us</a></li>
					</ul>
					<div class="ml-3 font-12">
						<span class="mr-3">© Bertazzoni Spa 2020</span>
						<span>VAT12637489</span>
					</div>
				</div>
			</div>
			<div class="col-lg-2 d-lg-flex justify-content-end mt-3">
				<a class="px-3 px-lg-2">
					<span class="icon-facebook font-16 text-white"></span>
				</a>
				<a class="px-3 px-lg-2">
					<span class="icon-twitter font-16 text-white"></span>
				</a>
				<a class="px-3 px-lg-2">
					<span class="icon-video font-16 text-white"></span>
				</a>
				<a class="px-3 px-lg-2">
					<span class="icon-instagram-sketched font-16 text-white"></span>
				</a>
				<a class="px-3 px-lg-2">
					<span class="icon-instagram-sketched font-16 text-white"></span>
					<!--pinterest-->
				</a>
				<a class="px-3 px-lg-2">
					<!--linkedin-->
					<span class="icon-linkedin2 font-16 text-white"></span>
				</a>
			</div>
		</div>
	</div>
</footer>
